<template>
  <div class="form-dossier">

    <div class="row">
      <div class="field col-md-6 mt-4">
        <input
          :value="dataForm.nom"
          type="text"
          @change="handleChangeNom($event.target.value)"
          id="nom"
          name="nom"
          class="form-control marge"
          placeholder=" "
          :disabled="desac"
          :class="{ isNotValid: !checkNom }"
        />
        <label class="labelForm">Nom</label>
      </div>

      <div class="field col-md-6 col-sm-12 mt-4">
        <input
          :value="dataForm.prenom"
          @change="handleChangePrenom($event.target.value)"
          type="text"
          id="prenom"
          name="prenom"
          class="form-control marge"
          :disabled="desac"
          :class="{ isNotValid: !checkPrenom }"
          placeholder=" "
        />
        <label class="labelForm">Prénom</label>
      </div>
    </div>

    <div class="row">
      <div class="field col-md-12 mt-4">
        <input
          :value="dataForm.telephone"
          @change="handleChangeTelephone($event.target.value)"
          type="text"
          id="telephone"
          name="telephone"
          class="form-control inputsize"
          :disabled="desac"
          :class="{ isNotValid: !checkTelephone }"
          placeholder=" "
        />
        <label class="labelForm">Téléphone</label>
      </div>
    </div>

    <div class="row">
      <div class="field col-md-6 col-sm-12 mt-4">
        <input
          :value="dataForm.dossier.nomUsage"
          @change="handleChangeNomUsage($event.target.value)"
          type="text"
          id="nomUsage"
          name="nomUsage"
          class="form-control marge"
          :disabled="desac"
          placeholder=" "
        />
        <label class="labelForm">Nom d'usage</label>
      </div>

      <div class="field col-md-6 col-sm-12 mt-4">
        <input
          :value="dataForm.dossier.autresPrenom"
          @change="handleChangeAutrePrenom($event.target.value)"
          type="text"
          id="autresPrenom"
          name="autresPrenom"
          class="form-control marge"
          :disabled="desac"
          placeholder=" "
        />
        <label class="labelForm">Autres prénoms</label>
      </div>
    </div>

    <div class="row">
      <div class="field col-md-6 col-sm-12 mt-4">
        <input
          :value="dateNaissanceFormated"
          @change="handleChangeDateNaissance($event.target.value)"
          type="date"
          id="dateNaissance"
          name="dateNaissance"
          class="form-control marge"
          :disabled="desac"
          :class="{ isNotValid: !checkDateNaissance }"
          placeholder=" "
        />
        <label class="labelForm">Date de naissance</label>
      </div>

      <div class="field col-md-6 col-sm-12 mt-4">
        <input
          :value="dataForm.dossier.adresse"
          @change="handleChangeAdresse($event.target.value)"
          type="text"
          id="adresse"
          name="adresse"
          class="form-control inputsize"
          :disabled="desac"
          :class="{ isNotValid: !checkAdresse }"
          placeholder=" "
        />
        <label class="labelForm">Adresse</label>
      </div>
    </div>

    <div class="row">
      <div class="field col-md-6 col-sm-12 mt-4">
        <input
          :value="dataForm.dossier.codePostal"
          @change="handleChangeCodePostal($event.target.value)"
          type="text"
          id="codePostal"
          name="codePostal"
          class="form-control"
          :disabled="desac"
          :class="{ isNotValid: !checkCodePostal }"
          placeholder=" "
        />
        <label class="labelForm">Code Postal</label>
      </div>

      <div class="field col-md-6 col-sm-12 mt-4">
        <input
          :value="dataForm.dossier.ville"
          @change="handleChangeVille($event.target.value)"
          type="text"
          id="ville"
          name="ville"
          class="form-control marge"
          :disabled="desac"
          :class="{ isNotValid: !checkVille }"
          placeholder=" "
        />
        <label class="labelForm">Ville</label>
      </div>
    </div>

    <div class="row">
      <div class="field col-md-6 col-sm-12 mt-4">
        <input
          :value="dataForm.dossier.telParent"
          @change="handleChangeTelParent($event.target.value)"
          type="text"
          id="telParent"
          name="telParent"
          class="form-control marge"
          :disabled="desac"
          :class="{ isNotValid: !checkTelParent }"
          placeholder=" "
        />
        <label class="labelForm">Téléphone parent</label>
      </div>

      <div class="field col-md-6 col-sm-12 mt-4">
        <input
          :value="dataForm.dossier.mailParent"
          @change="handleChangeMailParent($event.target.value)"
          type="text"
          id="mailParent"
          name="mailParent"
          class="form-control marge"
          :disabled="desac"
          :class="{ isNotValid: !checkMailParent }"
          placeholder=" "
        />
        <label class="labelForm">Mail parent</label>
      </div>
    </div>

    <div class="field col-md-12 mt-4">
      <select
        :value="dataForm.dossier.qNumNeph"
        @change="handleChangeQNumNeph($event.target.value)"
        id="numNephQ"
        name="numNephQ"
        class="form-select inputsize"
        placeholder=" "
        :disabled="desac"
        :class="{ isNotValid: !checkqNeph }"
      >
        <option value="null" disabled>Avez-vous un numéro NEPH ?</option>
        <option value="true">OUI</option>
        <option value="false">NON</option>
      </select>
      <label class="labelForm">Numéro NEPH</label>
    </div>

    <div v-if="dataForm.dossier.qNumNeph == 'true'">
      <div class="field col-md-12 mt-4">
        <input
          :value="dataForm.dossier.numNeph"
          @change="handleChangeNumNeph($event.target.value)"
          type="text"
          id="numNeph"
          name="numNeph"
          style="margin: auto"
          class="form-control marge"
          :disabled="desac"
          placeholder=" "
          :class="{ isNotValid: !checkNeph }"
        />
        <label class="labelForm">Numéro NEPH</label>
      </div>
    </div>


  </div>
  <div class="footer-form">
    <div><p v-if="error" class="errorMsg">{{ error }}</p></div>
    <div class="btnForm">
      <b-button @click="suivantEtape" class="btnForm">
        Suivant
      </b-button>
    </div>
    
  </div>
</template>

<script>
export default {
  name: "FormulairesStep1",
  props: {
    step: Number,
    dataForm: Object,
    desac: Boolean,
    qNumNeph: String,
    error: String,
    checkNom: Boolean,
    checkPrenom: Boolean,
    checkTelephone: Boolean,
    checkDateNaissance: Boolean,
    checkAdresse: Boolean,
    checkCodePostal: Boolean,
    checkVille: Boolean,
    checkTelParent: Boolean,
    checkMailParent: Boolean,
    checkqNeph: Boolean,
    checkNeph: Boolean,
    dateNaissanceFormated: String,
    handleChangeNom: Function,
    handleChangePrenom: Function,
    handleChangeTelephone: Function,
    handleChangeNomUsage: Function,
    handleChangeAutrePrenom: Function,
    handleChangeDateNaissance: Function,
    handleChangeAdresse: Function,
    handleChangeCodePostal: Function,
    handleChangeVille: Function,
    handleChangeTelParent: Function,
    handleChangeMailParent: Function,
    handleChangeQNumNeph: Function,
    handleChangeNumNeph: Function,
    suivantEtape: Function,
  },
};
</script>

<style scoped>
.field {
  position: relative;
}

.labelForm {
  position: absolute;
  pointer-events: none;
  left: 1.25rem;
  top: 7.75px;
  transition: 0.2s ease all;
  font-size: 15px;
}

.field > input:focus ~ label,
input:not(:placeholder-shown) ~ label,
.field > select:focus ~ label,
select:not(:placeholder-shown) ~ label {
  top: -15px;
  font-size: 12px;
}

.isNotValid {
  border-color: red;
}



div.btnForm {
  display: flex;
  justify-content: flex-end !important;
}

</style>
